export default {"src":"/_next/static/media/Icon1.79f900fd.svg","height":51,"width":50};